<script>
	const moment = require('moment');
	const utilities = require('utilities');
	const surveyUtilities = require('utilities/surveyUtilities');

	const createCVAAssignment = surveyUtilities.createCVAAssignment;

	module.exports = {
		props: {
			loading: {
				default: false
			},
			classes: {
				default: []
			}
		},
		watch: {
			classes(classes) {
				if (classes && classes.length) {
					this.selectedClass = classes[0].classCode;
				}
			}
		},
		methods: {
			submitSurveyAssignment() {
				let classes = this.classes;
				let cc = this.selectedClass;
				let d = this.startDate;
				let assignedClass = null;

				classes.every(c => {
					if (c.classCode === this.selectedClass) {
						assignedClass = c;
						return false;
					}
					return true;
				});

				this.loadingInternal = true;

				createCVAAssignment({ cc, d }).then(() => {
					this.loadingInternal = false;
					utilities.openModal('#modal-survey-confirm', {
						classCode: cc,
						startDate: d,
						name: assignedClass.name
					});
				});
			},
			close: function () {
				utilities.closeModals();
			}
		},
		data() {
			let startDate = moment().startOf('day').toDate().getTime();
			let selectedClass = null;
			let maxDate = surveyUtilities.currentSurveyEndDate;
			let minDate = surveyUtilities.currentSurveyStartDate;

			if (startDate < minDate) {
				startDate = minDate;
			} else if (minDate < startDate) {
				minDate = startDate;
			}

			return {
				selectedClass,
				startDate,
				maxDate,
				minDate,
				loadingInternal: false
			};
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-survey-assign"
		:ok="false"
		:loading="loading || loadingInternal">
		<template slot="header-container">
			<h2>Schedule</h2>
			<p>Vocabulary Quest<sup>beta</sup></p>
		</template>
		<form
			v-if="classes && classes.length"
			slot="content"
			v-on:submit.prevent="submitSurveyAssignment"
			class="survey-assign-modal-body">
			<label class="input-label">Class</label>
			<div class="form-row form-row-input input-select">
				<select
					v-model="selectedClass"
					class="input"
					required>
					<option
						v-for="c in classes"
						:key="c.classCode"
						:value="c.classCode">
						{{ c.name }}
					</option>
				</select>
			</div>
			<div class="start-date date">
				<div class="label">Start Date</div>
				<div class="form-row-input">
					<date-picker
						:date.sync="startDate"
						:min-date="minDate"
						:max-date="maxDate"
						required>
					</date-picker>
				</div>
			</div>
			<br />
			<div class="margin-top-bottom-medium">
				Please note:
				<ul>
					<li>You must assign Vocabulary Quest<sup>beta</sup> to the whole class.</li>
					<li>You cannot assign to individual students.</li>
					<li>The Quest consists of 20 questions and students should be able to complete it in 7-10 minutes.</li>
					<li>The Quest should be completed by the class in one day, in one sitting.</li>
				</ul>
			</div>
			<div class="text-centered">
				<button
					class="button"
					type="submit">
					Schedule
				</button>
			</div>
		</form>
	</modal>
</template>
